import Layout from '../../../layout/Layout';
import { LoadingButton } from '@mui/lab';
import {
  Grid,
  TextField,
  Typography,
  FormControl,
  FormHelperText,
} from '@mui/material';
//date picker
import { MobileDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Button from '@mui/material/Button';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import React, { useEffect, useRef, useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import StateList, { stateList } from '../../../components/StateList';
import { AlertMessage } from '../../../components/AlertMessage';
import axios from 'axios';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
  config,
  statusMasterAPI,
  handleHrMasterAPI,
  positionMasterAPI,
  departmentMasterAPI,
  ifscCodeRegExp,
  bankaccountnumberRegExp,
  phoneRegExp,
  manageCompaniesAPI,
  ImageUploadAPI,
} from '../../../config';
import { _getDropdownListData } from '../../../service';
import Employee from '../../../assets/images/employee.png';

function AddEmployee() {
  const nav = useNavigate();

  const [btnFlag, setBtnFlag] = useState(false);

  const validationSchema = Yup.object().shape({
    txtEmployeeName: Yup.string()
      .required('Employee Name is required')
      .matches(/^[A-Za-z\s\.]+$/, 'Only alphabets, spaces and dot are allowed'),

    txtEmail: Yup.string()
      .required('Email Id is required')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|org|net)$/,
        'Must be a valid email like abc@gmail.com'
      ),

    intPhone: Yup.string()
      .required('Mobile Number is required')
      .matches(/^[6-9]\d{9}$/, 'Please Enter A Valid Mobile Number'),

    txtDob: Yup.string().required('Date of Birth is required'),

    txtAddress: Yup.string().required('Street address is required'),

    txtCity: Yup.string()
      .required('Town / City is required')
      .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed'),

    txtState: Yup.string().required('State is required'),

    intPincode: Yup.string()
      .required('Pincode is required')
      .matches(/^\d{6}$/, 'Pincode must be exactly 6 digits'),

    txtGender: Yup.string().required('Gender is required'),

    txtBloodGroup: Yup.string().required('Blood Group is required'),

    txtMaritalStatus: Yup.string().required('Marital Status is required'),

    intAadharno: Yup.string()
      .required('Aadhar Number is required')
      .matches(/^\d{12}$/, 'Aadhar must be exactly 12 digits'),

    txtQualification: Yup.string()
      .required('Qualification is required')
      .matches(
        /^[a-zA-Z\s\.\-]+$/,
        'Only letters, hyphen (-), and dot (.) allowed'
      ),

    txtWorkExperience: Yup.string()
      .required('Work Experience is required')
      .matches(/^\d+$/, 'Work Experience must be a number'),

    txtGuardianName: Yup.string()
      .required('Emergency Contact is required')
      .matches(/^[A-Za-z\s\.]+$/, 'Only alphabets, spaces and dot are allowed'),

    txtRelationship: Yup.string()
      .required('Emergency Contact Relationship is required')
      .matches(/^[A-Za-z\s]+$/, 'Only alphabets and spaces are allowed'),

    intRelationNumber: Yup.string()
      .required('Emergency Contact Phone Number is required')
      .matches(/^[6-9]\d{9}$/, 'Phone Number is not valid'),

    txtDateofJoin: Yup.string().required('Date of Join is required'),

    txtCompanyName: Yup.string().required('Company Name is required'),

    txtDepartment: Yup.string().required('Department is required'),

    txtPosition: Yup.string().required('Position is required'),

    intPayScale: Yup.string().matches(
      /^\d+$/,
      'Please Enter Valid Pay Scale (numbers only)'
    ),

    txtRecruitmentSource: Yup.string().required(
      'Recruitment Source is required'
    ),

    intRdEsiNo: Yup.string()
      .required('ESI Number is required')
      .matches(/^\d{11,18}$/, 'ESI Number should be 11-18'),

    intRdAccNo: Yup.string()
      .required('RD Account Number is required')
      .matches(/^\d{9,18}$/, 'RD Account Number should be 9-18'),

    intLifeInsurance: Yup.string()
      .required('Life Insurance is required')
      .matches(/^\d{1,3}$/, 'Life Insurance should be 1 to 3 digits'),

    txtBankName: Yup.string()
      .required('Bank Name is required')
      .matches(/^[A-Za-z\s]+$/, 'Only alphabets and spaces are allowed'),

    txtIfscCode: Yup.string()
      .required('IFSC Code is required')
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Please enter a valid IFSC Code'),

    txtBranch: Yup.string()
      .required('Branch is required')
      .matches(/^[A-Za-z\s]+$/, 'Only alphabets and spaces are allowed'),

    txtAccountNumber: Yup.string()
      .required('Account Number is required')
      .matches(
        /^\d{9,18}$/,
        'Please enter a valid Account Number (9 to 18 digits)'
      ),

    intIncomeTax: Yup.string().matches(/^\d+$/, 'Income Tax must be a number'),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  // form dropdown
  const [DateofBirth, setDateofBirth] = React.useState(
    dayjs().format('YYYY-MM-DD')
  );
  const [DateofJoin, setDateofJoin] = React.useState(
    dayjs().format('YYYY-MM-DD')
  );
  const [txtLeaveEligible, setTxtLeaveEligible] = React.useState('');
  const [txtEpf, setTxtEpf] = React.useState('no');

  // const handleChange = (event) => {
  //   setLeaveEligible(event.target.value);
  // };

  // const [txtRecruitmentSource, setRecruitmentSource] = React.useState("");

  // const handleChangeSource = (event) => {
  //   setRecruitmentSource(event.target.value);
  //   setValue("txtRecruitmentSource", event.target.value);
  // };

  //Gender Details
  const [lstGender, setLstGender] = useState([]);
  const [txtGender, setGender] = useState('');
  let tempRef = useRef(false);
  useEffect(() => {
    if (tempRef.current === false) {
      const data = {
        intType: 2,
        intParentId: 4,
      };

      config.method = 'POST';
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setLstGender(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRef.current = true;
      };
    }
  }, []);

  //Marital Details
  const [MaritalDetails, setMarritalDetails] = useState([]);

  let tempRefs = useRef(false);
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 2,
        intParentId: 17,
      };

      config.method = 'POST';
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setMarritalDetails(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  //Blood Details
  const [lstBloogGroup, setlstBloogGroup] = useState([]);

  tempRefs.current = false;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 2,
        intParentId: 8,
      };

      config.method = 'POST';
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setlstBloogGroup(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  const [baseImage, setBaseImage] = useState(Employee);

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  //Department Details
  const [lstDepartment, setLstDepartment] = useState([]);
  const [txtDepartment, setTxtDepartment] = useState('');
  tempRefs.current = false;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 3,
      };

      config.method = 'POST';
      config.data = JSON.stringify(data);
      config.url = departmentMasterAPI;

      axios(config)
        .then(function (response) {
          setLstDepartment(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  //Position Details
  const [lstPosition, setLstPosition] = useState([]);
  // const [txtPosition, setTxtPosition] = useState("");

  const setDepartmentValues = (e) => {
    setTxtDepartment(e.target.value);
    setValue('txtDepartment', e.target.value, { shouldValidate: true });

    tempRefs.current = false;

    if (tempRefs.current === false) {
      const data = {
        intDepartmentID: e.target.value,
        intType: 4,
      };

      config.method = 'POST';
      config.data = JSON.stringify(data);
      config.url = positionMasterAPI;

      axios(config)
        .then(function (response) {
          setLstPosition(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  };

  const [companyList, setComanyList] = useState([]);

  // Getting Company List
  useEffect(() => {
    let data = {
      requestData: {
        intType: 5,
      },
      API: manageCompaniesAPI,
      setData: setComanyList,
    };

    _getDropdownListData(data);
  }, []);

  const [txtCompanyName, setTxtCompanyName] = useState('');

  // Login
  async function onSubmit(data) {
    const data1 = JSON.stringify({
      txtEmployeeStatus: '',
      txtProfile: baseImage,
      txtEmployeeName: data.txtEmployeeName,
      txtEmail: data.txtEmail,
      txtPhone: data.intPhone,
      intSecondaryNumber: data.intSecondaryNumber,
      intAadharno: data.intAadharno,
      txtGender: data.txtGender,
      txtDob: DateofBirth,
      txtMaritalStatus: data.txtMaritalStatus,
      txtAddress: data.txtAddress,
      txtCity: data.txtCity,
      txtState: data.txtState,
      intPincode: data.intPincode,
      txtBloodGroup: data.txtBloodGroup,
      txtPosition: data.txtPosition,
      txtDateofJoin: DateofJoin,

      txtCompanyName: txtCompanyName,

      txtDepartment: data.txtDepartment,
      txtRecruitmentSource: data.txtRecruitmentSource,
      txtQualification: data.txtQualification,
      txtWorkExperience: data.txtWorkExperience,
      txtGuardianName: data.txtGuardianName,
      txtRelationship: data.txtRelationship,
      intRelationNumber: data.intRelationNumber,
      intPayScale: data.intPayScale,
      intRdEsiNo: data.intRdEsiNo,
      txtRdEsi: data.txtRdEsi,
      intRdAccNo: data.intRdAccNo,
      txtRd: data.txtRd,
      txtBankName: data.txtBankName,
      txtAccountNumber: data.txtAccountNumber,
      txtIfscCode: data.txtIfscCode,
      txtBranch: data.txtBranch,
      txtLeaveEligible: txtLeaveEligible,
      txtEpf: txtEpf,
      intGeneralProvidentFund: data.intGeneralProvidentFund,
      intLifeInsurance: data.intLifeInsurance,
      intPostalLifeInsurance: data.intPostalLifeInsurance,
      intIncomeTax: data.intIncomeTax,
      intType: 1,
      intOffset: 0,
      intLimit: 0,
      txtPassword: '',
    });

    config.method = 'POST';
    config.data = data1;
    config.url = handleHrMasterAPI;

    axios(config)
      .then(function (response) {
        // handleFormReset();
        // window.location.reload(false);
        if (response.status == 204) {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: 'Email Already Exists',
              messageType: 'error',
            })
          );
        } else {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: response.data.message,
              messageType: 'success',
            })
          );

          //Add setTimeout to navigate after 2 seconds
          setTimeout(function () {
            nav('/employee/list');
          }, 2000);
        }
      })
      .catch(function (error) {
        console.log(error);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: 'Something went wrong',
            messageType: 'error',
          })
        );
      })
      .finally(function () {
        setBtnFlag(false);
      });
  }

  useEffect(() => {
    // handleFormReset();
  }, []);

  const handleFormReset = () => {
    let defaultValues = {};
    // defaultValues.txtEmployeeName = null;
    reset({ ...defaultValues });
  };

  const childRef = useRef();

  const [userInfo, setuserInfo] = useState({
    file: [],
    filepreview: null,
  });

  const handleInputChange = (event) => {
    setuserInfo({
      ...userInfo,
      file: event.target.files[0],
      filepreview: URL.createObjectURL(event.target.files[0]),
    });
  };

  const [isSucces, setSuccess] = useState(null);

  const submit = async () => {
    const formdata = new FormData();
    formdata.append('avatar', userInfo.file);

    axios
      .post('http://localhost:8080/imageupload', formdata, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => {
        // then print response status
        console.warn(res);
        if (res.data.success === 1) {
          setSuccess('Image upload successfully');
        }
      });
  };
  const [stateName, setStateName] = React.useState('');

  const options = stateList.map((option) => {
    const firstLetter = option.state_name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    };
  });

  return (
    <Layout>
      <AlertMessage ref={childRef} />
      <Grid className='employee-form'>
        <Grid container spacing={3}>
          <Grid
            textAlign='center'
            item
            className='form-lable'
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className='page_title' textAlign='left'>
              Add Employee
            </Typography>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link underline='hover' color='inherit' href='/dashboard'>
                Dashboard
              </Link>
              <Typography color='text.primary'>Add Employee</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign='right'
            item
            className='form-lable'
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size='medium'
              variant='contained'
              color='secondary'
              className='button_first'
              href='/employee/list'
            >
              List Employee
            </LoadingButton>
          </Grid>
        </Grid>
        <form className='form_design' onSubmit={handleSubmit(onSubmit)}>
          <Grid>
            <Grid
              textAlign='center'
              item
              className='form-lable'
              xs={12}
              lg={12}
              md={12}
            >
              {/* <Grid className="login-text-background">
              </Grid> */}
              {/* <h3>Personal Information</h3> */}
            </Grid>
            <div className='empty-space-20'></div>
            <Grid container spacing={3}>
              <Grid
                textAlign='center'
                item
                className='form-lable'
                xs={12}
                lg={3}
                md={3}
              >
                <Grid container spacing={3}>
                  <Grid item className='avatar-profile' alignItems='center'>
                    <Grid alignItems='center'>
                      <Grid className='profile_upload'>
                        <Button variant='contained' component='label'>
                          Upload
                          <input
                            {...register('txtProfile')}
                            onChange={(e) => {
                              uploadImage(e);
                            }}
                            hidden
                            accept='image/*'
                            multiple
                            type='file'
                          />
                        </Button>
                      </Grid>
                      <img className='avatar_img' src={baseImage} />
                      <h5 color='black'>Upload Profile Image</h5>
                      <Typography className='note'>
                        Allowed *.jpeg, *.jpg, *.png
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} lg={9} md={9}>
                <Grid container spacing={2}>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <TextField
                      name='empname'
                      type='text'
                      label='Employee Name'
                      fullWidth
                      {...register('txtEmployeeName')}
                      error={errors.txtEmployeeName ? true : false}
                      helperText={errors.txtEmployeeName?.message}
                    />
                  </Grid>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <TextField
                      name='emailid'
                      label='Email ID'
                      type='email'
                      fullWidth
                      {...register('txtEmail')}
                      error={errors.txtEmail ? true : false}
                      helperText={errors.txtEmail?.message}
                    />
                  </Grid>
                </Grid>
                <div className='empty-space-20'></div>
                <Grid container spacing={2}>
                  <Grid item className='form-lable' xs={12} lg={3} md={3}>
                    <TextField
                      name='phoneno'
                      label='Mobile Number'
                      type='text'
                      fullWidth
                      {...register('intPhone')}
                      error={errors.intPhone ? true : false}
                      helperText={errors.intPhone?.message}
                    />
                  </Grid>
                  <Grid item className='form-lable' xs={12} lg={3} md={3}>
                    <TextField
                      name='mobileno'
                      label='Secondary Mobile Number'
                      type='text'
                      fullWidth
                      {...register('intSecondaryNumber')}
                      error={errors.intSecondaryNumber ? true : false}
                      helperText={errors.intSecondaryNumber?.message}
                    />
                  </Grid>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      format='DD-MM-YYYY'
                    >
                      <MobileDatePicker
                        label='Date of Birth'
                        value={DateofBirth}
                        inputFormat='DD/MM/YYYY'
                        fullWidth
                        // minDate={new Date("02-01-2020")}
                        // maxDate={new Date("02-29-2020")}
                        {...register('txtDob')}
                        onChange={(newValue) => {
                          setDateofBirth(newValue);
                          setValue(
                            'txtDob',
                            dayjs(newValue).format('YYYY-MM-DD')
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            helperText={errors.txtDob?.message}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <div className='empty-space-20'></div>
                <Grid container spacing={2}>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <TextField
                      name='address'
                      type='text'
                      label='Street address'
                      fullWidth
                      {...register('txtAddress')}
                      error={errors.txtAddress ? true : false}
                      helperText={errors.txtAddress?.message}
                    />
                  </Grid>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <TextField
                      name='address'
                      type='text'
                      label='Town / City'
                      fullWidth
                      {...register('txtCity')}
                      error={errors.txtCity ? true : false}
                      helperText={errors.txtCity?.message}
                    />
                  </Grid>
                </Grid>
                <div className='empty-space-20'></div>
                <Grid container spacing={2}>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <FormControl
                      fullWidth
                      error={errors.txtState ? true : false}
                    >
                      <InputLabel id='demo-simple-select-label'>
                        State
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        // value={stateName}
                        label='State'
                        {...register('txtState')}
                      // onChange={(e) => {
                      //   setStateName(e.target.value);
                      //   setValue("txtState", e.target.value);
                      // }}
                      >
                        {stateList.map((row) => (
                          <MenuItem value={row.state_name}>
                            {row.state_name}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className='invalid-feedback'>
                        {errors.txtState?.message}
                      </FormHelperText>
                    </FormControl>
                    {/* <TextField
                      name="address"
                      type="text"
                      label="State"
                      fullWidth
                      {...register("txtState")}
                      error={errors.txtState ? true : false}
                      helperText={errors.txtState?.message}
                    /> */}
                  </Grid>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <TextField
                      name='address'
                      type='text'
                      label='Pincode'
                      fullWidth
                      {...register('intPincode')}
                      error={errors.intPincode ? true : false}
                      helperText={errors.intPincode?.message}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    {/* <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Gender
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        label="Gender"
                        id="demo-simple-select"
                        {...register("txtGender")}
                        // value={txtGender}
                        // onChange={(e) => {
                        //   setGender(e.target.value);
                        //   setValue("txtGender", e.target.value);
                        // }}
                      >
                        {lstGender.map((row, index) => (
                          <MenuItem value={row.name} key={index}>
                            {row.name}
                          </MenuItem>
                        ))}
                      </Select>
                        

                    </FormControl> */}

                    <FormControl
                      fullWidth
                      error={errors.txtGender ? true : false}
                    >
                      <InputLabel id='demo-simple-select-label'>
                        Gender
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        label='Gender'
                        id='demo-simple-select'
                        {...register('txtGender')}
                      >
                        {lstGender.map((row) => (
                          <MenuItem key={row.id} value={row.id}>
                            {row.name}
                          </MenuItem>
                        ))}
                      </Select>

                      <FormHelperText className='invalid-feedback'>
                        {errors.txtGender?.message}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <FormControl
                      fullWidth
                      error={errors.txtBloodGroup ? true : false}
                    >
                      <InputLabel id='demo-simple-select-label'>
                        Blood Group
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        //value={txtBloodGroup}
                        label='Blood Group'
                        {...register('txtBloodGroup')}

                      // onChange={(e) => {
                      //   setTxtBloodGroup(e.target.value);
                      //   setValue("txtBloodGroup", e.target.value);
                      // }}
                      >
                        {lstBloogGroup.map((row, index) => (
                          <MenuItem value={row.name} key={index}>
                            {row.name}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className='invalid-feedback'>
                        {errors.txtBloodGroup?.message}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <div className='empty-space-20'></div>
                <Grid container spacing={2}>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <FormControl
                      fullWidth
                      error={errors.txtMaritalStatus ? true : false}
                    >
                      <InputLabel id='demo-simple-select-label'>
                        Marital Status
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        //value={txtMaritalStatus}
                        label='Marital Status'
                        {...register('txtMaritalStatus')}
                      // onChange={(e) => {
                      //   setMaritalStatus(e.target.value);
                      //   setValue("txtMaritalStatus", e.target.value);
                      // }}
                      >
                        {MaritalDetails.map((row, index) => (
                          <MenuItem value={row.name} key={index}>
                            {row.name}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className='invalid-feedback'>
                        {errors.txtMaritalStatus?.message}
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <TextField
                      name='aadharnopassportno'
                      label='Aadhar / Passport Number'
                      type='text'
                      fullWidth
                      {...register('intAadharno')}
                      error={errors.intAadharno ? true : false}
                      helperText={errors.intAadharno?.message}
                    />
                  </Grid>
                </Grid>

                <div className='empty-space-20'></div>
                <Grid container spacing={2}>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <TextField
                      name='qualification'
                      type='text'
                      label='Qualification'
                      fullWidth
                      {...register('txtQualification')}
                      error={errors.txtQualification ? true : false}
                      helperText={errors.txtQualification?.message}
                    />
                  </Grid>
                  <Grid item className='form-lable' xs={12} lg={6} md={6}>
                    <TextField
                      name='workexperience'
                      type='text'
                      label=' Work Experience'
                      fullWidth
                      {...register('txtWorkExperience')}
                      error={errors.txtWorkExperience ? true : false}
                      helperText={errors.txtWorkExperience?.message}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid
                textAlign='center'
                item
                className='form-lable'
                xs={12}
                lg={12}
                md={12}
              >
                <h3>Emergency Contact Information</h3>
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='familyname'
                  type='text'
                  label='Name'
                  fullWidth
                  {...register('txtGuardianName')}
                  error={errors.txtGuardianName ? true : false}
                  helperText={errors.txtGuardianName?.message}
                />
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='relationship'
                  type='text'
                  label='Relationship'
                  fullWidth
                  {...register('txtRelationship')}
                  error={errors.txtRelationship ? true : false}
                  helperText={errors.txtRelationship?.message}
                />
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='RelationNumber'
                  label='Mobile Number'
                  type='text'
                  fullWidth
                  {...register('intRelationNumber')}
                  error={errors.intRelationNumber ? true : false}
                  helperText={errors.intRelationNumber?.message}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid
                textAlign='center'
                item
                className='form-lable'
                xs={12}
                lg={12}
                md={12}
              >
                <h3>Work Information</h3>
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  format='DD-MM-YYYY'
                >
                  <MobileDatePicker
                    label='Date of Joining'
                    value={DateofJoin}
                    inputFormat='DD/MM/YYYY'
                    fullWidth
                    {...register('txtDateofJoin')}
                    onChange={(newValue) => {
                      setDateofJoin(newValue);
                      setValue(
                        'txtDateofJoin',
                        dayjs(newValue).format('YYYY-MM-DD')
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        helperText={errors.txtDateofJoin?.message}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <FormControl fullWidth>
                  <InputLabel id='demo-simple-select-label'>
                    Leave Eligibility
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={txtLeaveEligible}
                    defaultValue='no'
                    label='Leave Eligibility'
                    fullWidth
                    onChange={(e) => {
                      setTxtLeaveEligible(e.target.value);
                      setValue('txtLeaveEligible', e.target.value, { shouldValidate: true });
                    }}
                  >
                    <MenuItem value='yes'>Yes</MenuItem>
                    <MenuItem value='no'>No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <div className='empty-space-20'></div>
            <Grid container spacing={2}>
              {/* // company */}
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <FormControl fullWidth error={!!errors.txtCompanyName}>
                  <InputLabel id='demo-simple-select-label'>Company</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={txtCompanyName}
                    label='Company'
                    onChange={(e) => {
                      setTxtCompanyName(e.target.value);
                      setValue('txtCompanyName', e.target.value, { shouldValidate: true });
                    }}
                  >
                    {companyList.map((row, index) => (
                      <MenuItem value={row.id} key={index}>
                        {row.company_name}
                      </MenuItem>
                    ))}
                  </Select>
                  <Typography className='invalid-feedback'>
                    {errors.txtCompanyName?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <FormControl
                  fullWidth
                  error={!!errors.txtDepartment}
                >
                  <InputLabel id='demo-simple-select-label'>
                    Department
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={txtDepartment}
                    label='Department'
                    onChange={setDepartmentValues}
                  // {...register('txtDepartment')}
                  >
                    {lstDepartment.map((row, index) => (
                      <MenuItem value={row.id} key={index}>
                        {row.department_name}
                      </MenuItem>
                    ))}
                  </Select>
                  <Typography className='invalid-feedback'>
                    {errors.txtDepartment?.message}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>
            <div className='empty-space-20'></div>
            <Grid container spacing={2}>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <FormControl
                  fullWidth
                  error={errors.txtPosition ? true : false}
                >
                  <InputLabel id='demo-simple-select-label'>
                    Position
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    // value={txtPosition}
                    label='Position'
                    {...register('txtPosition')}
                  // onChange={(e) => {
                  //   setTxtPosition(e.target.value);
                  //   setValue("txtPosition", e.target.value);
                  // }}
                  >
                    {lstPosition.length > 0 ? (
                      lstPosition.map((row, index) => (
                        <MenuItem value={row.id} key={index}>
                          {row.position_name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem style={{ backgroundColor: '#fff' }}>
                        No Data Found
                      </MenuItem>
                    )}
                  </Select>
                  <Typography className='invalid-feedback'>
                    {errors.txtPosition?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='payscale'
                  type='text'
                  label='Pay Scale (CTC)'
                  fullWidth
                  {...register('intPayScale')}
                  error={errors.intPayScale ? true : false}
                  helperText={errors.intPayScale?.message}
                />
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <FormControl fullWidth>
                  <InputLabel id='demo-epf-select-label'>
                    EPF
                  </InputLabel>
                  <Select
                    labelId='demo-epf-select-label'
                    id='demo-epf-select'
                    value={txtEpf}
                    defaultValue='no'
                    label='EPF'
                    fullWidth
                    {...register('txtEpf')}
                    onChange={(e) => {
                      setTxtEpf(e.target.value);
                      setValue('txtEpf', e.target.value, { shouldValidate: true });
                    }}
                  >
                    <MenuItem value='yes'>Yes</MenuItem>
                    <MenuItem value='no'>No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <div className='empty-space-20'></div>
            <Grid container spacing={2}>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <FormControl
                  fullWidth
                  error={errors.txtRecruitmentSource ? true : false}
                >
                  <InputLabel id='demo-simple-select-label'>
                    Recruitment Source
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    // value={txtRecruitmentSource}
                    label='Recruitment Source'
                    {...register('txtRecruitmentSource')}
                  // onChange={handleChangeSource}
                  >
                    <MenuItem value='job portal'>Job Portal</MenuItem>
                    <MenuItem value='linked in'>LinkedIn</MenuItem>
                    <MenuItem value='referral'>Referral</MenuItem>
                    <MenuItem value='other'>Other</MenuItem>
                  </Select>
                  <Typography className='invalid-feedback'>
                    {errors.txtRecruitmentSource?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='rdesiepfo'
                  type='text'
                  label='ESI Account Number' // ESI Field
                  fullWidth
                  {...register('intRdEsiNo')} // Account Number
                  error={errors.intRdEsiNo ? true : false}
                  helperText={errors.intRdEsiNo?.message}
                />
              </Grid>
              {/* <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='rdesiepof'
                  type='text'
                  label='ESI (Rupees)' // ESI Rupees field
                  fullWidth
                  {...register('txtRdEsi')} // ESI Rupees
                  error={errors.txtRdEsi ? true : false}
                  helperText={errors.txtRdEsi?.message}
                />
              </Grid> */}
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='rdesiepfo'
                  type='text'
                  label='RD Account Number' // RD Field
                  fullWidth
                  {...register('intRdAccNo')}
                  error={errors.intRdAccNo ? true : false}
                  helperText={errors.intRdAccNo?.message}
                />
              </Grid>
              {/* <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='rdesiepof'
                  type='text'
                  label='RD (Rupees)' // RD Rupees field
                  fullWidth
                  {...register('txtRd')}
                  error={errors.txtRd ? true : false}
                  helperText={errors.txtRd?.message}
                />
              </Grid> */}
              <div className='empty-space-20'></div>
              {/* <Grid container spacing={2}> */}
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='LifeInsurance'
                  type='text'
                  label='Life Insurance'
                  fullWidth
                  {...register('intLifeInsurance')}
                  error={errors.intLifeInsurance ? true : false}
                  helperText={errors.intLifeInsurance?.message}
                />
              </Grid>
              {/* </Grid> */}
              <div className='empty-space-20'></div>
              {/* <Grid container spacing={2}> */}
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='IncomeTax'
                  type='text'
                  label='Income Tax (Yrs)'
                  fullWidth
                  {...register('intIncomeTax')}
                  error={errors.intIncomeTax ? true : false}
                  helperText={errors.intIncomeTax?.message}
                />
              </Grid>
            </Grid>
            {/* </Grid> */}

            {/* <div className="empty-space-20"></div> */}
            {/* <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="GeneralProvidentFund"
                  type="text"
                  label="General Provident Fund"
                  fullWidth
                  {...register("intGeneralProvidentFund")}
                  error={errors.intGeneralProvidentFund ? true : false}
                  helperText={errors.intGeneralProvidentFund?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="PostalLifeInsurance"
                  type="text"
                  label="Postal Life Insurance"
                  fullWidth
                  {...register("intPostalLifeInsurance")}
                  error={errors.intPostalLifeInsurance ? true : false}
                  helperText={errors.intPostalLifeInsurance?.message}
                />
              </Grid>
            </Grid> */}
            <Grid container spacing={2}>
              <Grid
                textAlign='center'
                item
                className='form-lable'
                xs={12}
                lg={12}
                md={12}
              >
                <h3>Bank Information</h3>
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='bankname'
                  type='text'
                  label='Bank Name'
                  fullWidth
                  {...register('txtBankName')}
                  error={errors.txtBankName ? true : false}
                  helperText={errors.txtBankName?.message}
                />
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='ifsccode'
                  type='text'
                  label='IFSC Code'
                  fullWidth
                  {...register('txtIfscCode')}
                  error={errors.txtIfscCode ? true : false}
                  helperText={errors.txtIfscCode?.message}
                />
              </Grid>
            </Grid>
            <div className='empty-space-20'></div>
            <Grid container spacing={2}>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='branch'
                  type='text'
                  label='Bank Branch'
                  fullWidth
                  {...register('txtBranch')}
                  error={errors.txtBranch ? true : false}
                  helperText={errors.txtBranch?.message}
                />
              </Grid>
              <Grid item className='form-lable' xs={12} lg={6} md={6}>
                <TextField
                  name='yearofcompletion'
                  type='text'
                  label='Bank Account Number'
                  fullWidth
                  {...register('txtAccountNumber')}
                  error={errors.txtAccountNumber ? true : false}
                  helperText={errors.txtAccountNumber?.message}
                />
              </Grid>
            </Grid>
            <FormControl
              sx={{ m: 0, width: '-webkit-fill-available' }}
              variant='standard'
            >
              <Grid container className='submit-button' alignItems='center'>
                <Grid item xs={12} lg={12} md={12}>
                  <LoadingButton
                    size='large'
                    variant='contained'
                    color='primary'
                    type='submit'
                    disabled={formState.isSubmitting}
                  >
                    Submit
                  </LoadingButton>
                </Grid>
              </Grid>
            </FormControl>
          </Grid>
        </form>
      </Grid>
    </Layout>
  );
}

export default AddEmployee;
